import React from 'react';
import { ClientDealTable } from '@/components/tables/ClientDealTable';

export const ClaimsTab = () => {
	return <ClientDealTable pipeline={process.env.REACT_APP_PIPELINE_CLAIMS} />;
};
ClaimsTab.displayName = 'ClaimsTab';
